module.exports = __webpack_public_path__ + "static/media/fly0208.d89d3d88.webp";